import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getAllCCMConsentFormByPatientId (patientId) {
		const response = await _axios.get(`/ccmconsentform/getbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		} else if (response.data.msg === 'No Ccm consent forms found.') {
			return [];
		}
		throw new CCMError('Error getting all CCM ConsentForms by patient ID');
	},
	async getSingleCCMConsentFormByPatientId (ccmRecordId, consentFormId) {
		const response = await _axios.get(`/ccmconsentform/${ccmRecordId}/${consentFormId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM ConsentForm by CCM record ID');
	},
	async getCCMConsentForm (id) {
		const response = await _axios.get(`/ccmconsentform/${id}`, { responseType: 'blob' });
		if (response.data) {
			return response.data;
		}
		throw new CCMError('Error getting CCM ConsentForm');
	},
	async addCCMConsentForm (body) {
		const response = await _axios.post('/ccmconsentform', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error adding CCM ConsentForm');
	},
	async deleteCCMConsentForm (id) {
		const response = await _axios.delete(`/ccmconsentform/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error deleting CCM ConsentForm');
	},
};
